var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { OffresSchema } from '../../utils/ValidationSchema';
import * as ServiceOffre from '../../services/offre';
import { Grid, Stack, TableContainer, Paper, Table, TableHead, TableBody, TableRow, TableCell, } from '@mui/material';
import { FieldArray } from 'formik';
import { Fragment, useEffect, useState } from 'react';
import { Modal } from '../../utils/Modal';
import { TYPES } from '../../utils/FormikTextField';
import { IconButton } from '../../utils/IconButton';
import { AddIcon, AffaireIcon, CloseIcon, } from '../../utils/Icons';
import { formatNumber } from '../../services/utils/utils';
import { FormikGenerator, OPTIONS_ASYNC } from '../../utils/FormikGenerator';
import { Loader } from '../../utils/Loader';
import * as ServiceUtils from '../../services/utils';
var COLLABORATEUR_INCONNU = 'Collaborateur inconnu';
export var EditionOffre = function (_a) {
    var AffaireId = _a.AffaireId, offre = _a.offre, handleClose = _a.handleClose;
    var _b = useState(true), loading = _b[0], setLoading = _b[1];
    var _c = useState([]), catalogues = _c[0], setCatalogues = _c[1];
    var _d = useState([]), famillesCatalogue = _d[0], setFamillesCatalogue = _d[1];
    var _e = useState([]), collaborateurs = _e[0], setCollaborateurs = _e[1];
    useEffect(function () {
        var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var datas;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            ServiceUtils.getListe('CatalogueFamille'),
                            ServiceUtils.getListe('Offre', 'Catalogue'),
                            ServiceUtils.getSelectOptions(OPTIONS_ASYNC.COLLABORATEUR, {
                                AffaireId: AffaireId,
                            }),
                        ])];
                    case 1:
                        datas = _a.sent();
                        setFamillesCatalogue(datas[0]);
                        setCatalogues(datas[1]);
                        setCollaborateurs(datas[2]);
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        if (loading) {
            getData();
        }
    }, [loading]);
    var renderForm = function () { return (_jsx(_Fragment, { children: _jsx(FormikGenerator, { validationSchema: OffresSchema, submitLabel: offre && offre.IdOffre ? 'Enregistrer' : 'Ajouter', datas: offre && offre.IdOffre ? offre : ServiceOffre.newOffre(AffaireId), validate: function (_a) {
                var values = _a.values;
                var pourcentageCalcule = values.offre__collaborateurs
                    ? values.offre__collaborateurs
                        .filter(function (item) { return !item.Deleted; })
                        .reduce(function (total, collaborateur) {
                        return total + parseFloat(collaborateur.Pourcentage);
                    }, 0)
                    : 0;
                if (pourcentageCalcule !== 100) {
                    return "Le produit / service n'est pas partag\u00E9e \u00E0 100 % (".concat(pourcentageCalcule, " %)");
                }
                return null;
            }, onSubmit: function (offre) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, ServiceOffre.postOffre(AffaireId, offre)];
                        case 1:
                            _a.sent();
                            if (handleClose) {
                                handleClose();
                            }
                            return [2 /*return*/];
                    }
                });
            }); }, fields: [], additionalInitialValues: Object.keys(offre && offre.IdOffre ? offre : ServiceOffre.newOffre(AffaireId)), renderContent: function (_a) {
                var values = _a.values, renderField = _a.renderField, setFieldValue = _a.setFieldValue, setFieldTouched = _a.setFieldTouched;
                var offreCollaborateurs = values.offre__collaborateurs
                    ? values.offre__collaborateurs.map(function (item) {
                        var collaborateurOption = collaborateurs.find(function (x) { return x.value === item.CollaborateurId; });
                        item.label = collaborateurOption
                            ? collaborateurOption.label
                            : COLLABORATEUR_INCONNU;
                        return item;
                    })
                    : [];
                return (_jsx(_Fragment, { children: _jsxs(Grid, __assign({ container: true, spacing: 2, padding: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12 }, { children: renderField({
                                    label: 'Gamme de produit / service',
                                    name: "CatalogueFamilleId",
                                    type: TYPES.SELECT,
                                    afterChange: function () {
                                        setFieldValue("CatalogueId", null);
                                        setFieldValue("Designation", null);
                                    },
                                    helperText: values.TypeCatalogueLibelle
                                        ? values.TypeCatalogueLibelle
                                        : null,
                                    options: famillesCatalogue ? famillesCatalogue : [],
                                    isRequired: true,
                                }) })), _jsx(Grid, __assign({ item: true, xs: 12 }, { children: renderField({
                                    label: 'Produit / Service',
                                    name: "CatalogueId",
                                    type: TYPES.SELECT,
                                    afterChange: function (value) {
                                        var catalogue;
                                        if (value) {
                                            catalogue = catalogues.find(function (catalogue) { return catalogue.IdCatalogue === value; });
                                        }
                                        var Quantite = catalogue ? catalogue.Quantite : 0;
                                        var Tarif = catalogue ? catalogue.Tarif : 0;
                                        var Cout = catalogue ? catalogue.Cout : 0;
                                        setFieldValue("Designation", catalogue && catalogue.Libelle
                                            ? catalogue.Libelle
                                            : null);
                                        setFieldValue("TypeCatalogueLibelle", catalogue &&
                                            catalogue.Catalogue_Famille &&
                                            catalogue.Catalogue_Famille.Type &&
                                            catalogue.Catalogue_Famille.Type.Libelle
                                            ? catalogue.Catalogue_Famille.Type.Libelle
                                            : null);
                                        setFieldValue("WithQuantite", catalogue ? catalogue.WithQuantite : true);
                                        setFieldValue("Quantite", Quantite);
                                        setFieldValue("Unite", catalogue ? catalogue.Unite : null);
                                        setFieldValue("Tarif", Tarif);
                                        setFieldValue("Cout", Cout);
                                        setTimeout(function () { return setFieldTouched('Designation', true); });
                                    },
                                    options: catalogues
                                        ? catalogues.map(function (c) {
                                            return {
                                                value: c.IdCatalogue,
                                                label: c.Libelle,
                                                params: {
                                                    CatalogueFamilleId: c.CatalogueFamilleId,
                                                },
                                                show: function (params) {
                                                    return (values.CatalogueFamilleId &&
                                                        params.CatalogueFamilleId ===
                                                            values.CatalogueFamilleId);
                                                },
                                            };
                                        })
                                        : [],
                                    isRequired: true,
                                }) })), _jsx(Grid, __assign({ item: true, xs: 12 }, { children: renderField({
                                    label: 'Désignation',
                                    name: "Designation",
                                    type: TYPES.TEXT,
                                }) })), _jsx(Grid, __assign({ item: true, xs: 12 }, { children: renderField({
                                    name: "WithQuantite",
                                    type: TYPES.BOOLEAN,
                                    label: 'Avec quantité',
                                    afterChange: function () {
                                        setFieldValue("Quantite", 1);
                                    },
                                }) })), values.WithQuantite ? (_jsxs(_Fragment, { children: [_jsx(Grid, __assign({ item: true, xs: 12, md: 6 }, { children: renderField({
                                            label: 'Quantité',
                                            name: "Quantite",
                                            type: TYPES.TEXT,
                                            onlyDigits: true,
                                            smallerThanZero: true,
                                        }) })), _jsx(Grid, __assign({ item: true, xs: 12, md: 6 }, { children: renderField({
                                            label: 'Unité',
                                            name: "Unite",
                                            type: TYPES.TEXT,
                                        }) }))] })) : (_jsx(_Fragment, {})), _jsx(Grid, __assign({ item: true, xs: 12, md: 6 }, { children: renderField({
                                    label: values.WithQuantite
                                        ? 'Tarif unitaire'
                                        : 'Tarif total',
                                    name: "Tarif",
                                    type: TYPES.TEXT,
                                    onlyDigits: true,
                                    smallerThanZero: true,
                                    helperText: "Total ".concat(formatNumber(values.Tarif * values.Quantite, '€')),
                                }) })), _jsx(Grid, __assign({ item: true, xs: 12, md: 6 }, { children: renderField({
                                    label: values.WithQuantite ? 'Coût unitaire' : 'Coût total',
                                    name: "Cout",
                                    type: TYPES.TEXT,
                                    onlyDigits: true,
                                    smallerThanZero: true,
                                    helperText: "Total ".concat(formatNumber(values.Cout * values.Quantite, '€')),
                                }) })), _jsxs(Grid, __assign({ item: true, xs: 12 }, { children: [_jsx(TableContainer, __assign({ component: Paper }, { children: _jsxs(Table, __assign({ className: "mt-small" }, { children: [_jsx(TableHead, { children: _jsxs(TableRow, __assign({ sx: {
                                                            backgroundColor: 'affaire.main',
                                                        } }, { children: [_jsx(TableCell, __assign({ sx: {
                                                                    color: 'white.main',
                                                                } }, { children: "Collaborateur" })), _jsx(TableCell, __assign({ sx: {
                                                                    color: 'white.main',
                                                                    width: 130,
                                                                } }, { children: "Pourcentage" }))] })) }), _jsx(TableBody, { children: _jsx(FieldArray, { name: "offre__collaborateurs", render: function () {
                                                            return offreCollaborateurs.map(function (collaborateur, indexCollaborateur) {
                                                                if (collaborateur.Deleted) {
                                                                    return _jsx(Fragment, {}, indexCollaborateur);
                                                                }
                                                                return (_jsxs(TableRow, { children: [_jsx(TableCell, { children: renderField({
                                                                                name: "offre__collaborateurs[".concat(indexCollaborateur, "].CollaborateurId"),
                                                                                type: TYPES.SELECT,
                                                                                options: collaborateurs
                                                                                    ? collaborateurs
                                                                                    : [],
                                                                                isRequired: true,
                                                                            }) }), _jsx(TableCell, { children: _jsxs(Stack, __assign({ direction: "row", spacing: 1 }, { children: [renderField({
                                                                                        name: "offre__collaborateurs[".concat(indexCollaborateur, "].Pourcentage"),
                                                                                        type: TYPES.TEXT,
                                                                                        onlyDigits: true,
                                                                                        isRequired: true,
                                                                                    }), offreCollaborateurs.filter(function (item) { return !item.Deleted; }).length > 1 && (_jsx(IconButton, __assign({ color: "error", tooltip: "Retirer le collaborateur", onClick: function () {
                                                                                            setFieldValue("offre__collaborateurs[".concat(indexCollaborateur, "].Deleted"), true);
                                                                                        } }, { children: _jsx(CloseIcon, {}) })))] })) })] }, indexCollaborateur));
                                                            });
                                                        } }) })] })) })), _jsx(IconButton, __assign({ color: "primary", tooltip: "Ajouter un collaborateur", onClick: function () {
                                            setFieldValue("offre__collaborateurs", __spreadArray(__spreadArray([], offreCollaborateurs, true), [
                                                ServiceOffre.newCollaborateurInOffre(offreCollaborateurs),
                                            ], false));
                                        } }, { children: _jsx(AddIcon, {}) }))] }))] })) }));
            } }) })); };
    return (_jsx(_Fragment, { children: _jsx(Modal, __assign({ smallModal: true, handleCloseModal: handleClose, forceOpen: true, title: "Offre", color: "affaire", iconTitle: _jsx(AffaireIcon, {}) }, { children: loading ? _jsx(Loader, {}) : renderForm() })) }));
};
//# sourceMappingURL=EditionOffre.js.map